module.exports = __webpack_public_path__ + "static/media/LandingDashboard.ee3b9fa0.svg";